import { TcRegion } from '../services/tc-tcps-api-service.models';

/**
 * Extracts the base URL for Trimble Connect API calls from a region,
 * stripping any trailing slash to match API endpoint expectations.
 */
export function getRegionalBaseUrl(region: Pick<TcRegion, 'tc-api'>): string {
  const url = region['tc-api'];
  return url.endsWith('/') ? url.slice(0, -1) : url;
}
